import { $CurrentABTest } from '@lemon8/web-app-shared/atom';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';
import { $IsMobileUser } from '../is-mobile-user';

const $ArticleRelatedPostSingle: Atom<boolean> = atom((get) => {
  // use currentABTest to avoid server and client parameters not same
  const { parameters } = get($CurrentABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return true;
  }
  return _get(parameters, ['seo_web', 'lemon8.article_related_post_single'], false);
});

export const $HitArticleRelatedPostSingle: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const config = get($ArticleRelatedPostSingle);

  return isMobileUser && config;
});
